import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const OTPPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mobile, uotp } = location.state || {};
  
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const inputRefs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];

  const handleChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < inputRefs.length - 1) {
      inputRefs[index + 1].current.focus();
    }
  };

  const handleBackspace = (key, index) => {
    if (key === "Backspace" && index > 0 && !otp[index]) {
      inputRefs[index - 1].current.focus();
    }
  };

  const verifyOTP = async () => {
  const otpCode = otp.join("");
  if (otpCode !== uotp) {
    alert("Please enter a 6-digit Valid OTP.");
    return;
  }

  setLoading(true);
  try {
    // Create FormData object
    const formData = new FormData();
    formData.append('mobile', mobile);

    const response = await fetch(
      "https://singlewindowsecurities.com/rest3/otp_verify_api22",
      {
        method: "POST",
        body: formData,
        // Do NOT set Content-Type header when using FormData
        // The browser will set it automatically with boundary
      }
    );

    const data = await response.json();
    console.log(data);
    
    // Store user data
    localStorage.setItem("userid", data.id);
    localStorage.setItem("name", data.first_name);
    localStorage.setItem("email", data.email);
    localStorage.setItem("mobile", data.mobile);

    navigate("/dashboard");
  
  } catch (error) {
    alert("Something went wrong. Please try again later.");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="container-fluid p-0 bg-light" style={{ minHeight: '100vh' }}>
      {/* Header */}
      <div className="bg-white border-bottom shadow-sm">
        <div className="container py-2">
          <div className="d-flex justify-content-between align-items-center">
            <button 
              className="btn btn-outline-primary btn-sm rounded-circle p-1"
              onClick={() => navigate(-1)}
              style={{ width: '32px', height: '32px' }}
            >
              <i className="fa fa-arrow-left"></i>
            </button>
            
            <h6 className="mb-0 fw-bold">OTP Verification</h6>
            
            <div style={{ width: '32px' }}></div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container">
        {/* Verification Card */}
        <div className="card border-0 shadow-sm mt-4">
          <div className="card-body p-4 text-center">
            <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex p-3 mb-3">
              <i className="fa fa-chat-dots-fill text-primary fs-2"></i>
            </div>
            
            <h5 className="fw-bold mb-2">Enter Verification Code</h5>
            <p className="text-muted small">
              We've sent a 6-digit code to {mobile}
            </p>
          </div>
        </div>

        {/* OTP Input Section */}
        <div className="mt-4">
          <small className="text-muted fw-semibold d-block mb-2">ENTER OTP</small>
          <div className="d-flex justify-content-between mb-4">
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={inputRefs[index]}
                type="text"
                className={`form-control text-center ${digit ? 'border-primary' : ''}`}
                style={{
                  width: '45px',
                  height: '50px',
                  fontSize: '1.2rem',
                  fontWeight: 'bold'
                }}
                maxLength={1}
                value={digit}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleBackspace(e.key, index)}
              />
            ))}
          </div>
        </div>

        {/* Submit Button */}
        <button
          className={`btn btn-primary w-100 py-3 mb-3 ${loading ? 'disabled' : ''}`}
          onClick={verifyOTP}
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status"></span>
              Verifying...
            </>
          ) : (
            'VERIFY OTP'
          )}
        </button>

        {/* Resend OTP */}
        <div className="text-center">
          <small className="text-muted">
            Didn't receive the OTP?{' '}
            <button className="btn btn-link p-0 text-primary">
              Resend Now
            </button>
          </small>
        </div>
      </div>
    </div>
  );
};

export default OTPPage;